import { useEffect } from 'react';

import { useStateSettingsContext } from '../api/StateSettingsContext';

/**
 * Injects a <style> tag into the document head that overrides the
 * --state-{id} CSS custom properties with admin-chosen colours from
 * the state_setting table. Mounts once at the top of the app tree
 * (in App.tsx) so the override is present before any state-coloured
 * UI renders.
 *
 * Renders nothing — side-effect only.
 */
export function GlobalStateStyles() {
  const settings = useStateSettingsContext();

  useEffect(() => {
    if (!settings.map) return;
    const overrides: string[] = [];
    for (const row of settings.map.values()) {
      if (row.colour && /^#[0-9a-fA-F]{6}$/.test(row.colour)) {
        overrides.push(`--state-${row.state_id}: ${row.colour};`);
      }
    }
    if (overrides.length === 0) return;
    const style = document.createElement('style');
    style.setAttribute('data-source', 'wfp-state-overrides');
    style.textContent = `:root { ${overrides.join(' ')} }`;
    document.head.appendChild(style);
    return () => {
      style.remove();
    };
  }, [settings]);

  return null;
}

export default GlobalStateStyles;
